export default __webpack_public_path__ + "static/media/consignee.21af142c.svg";